import { useSessionStore } from "~/modules/shared/composables/stores/SessionStore";
import { isLoadingSpinner, toastError } from "~/modules/shared/composables/utils/Helpers";
import { QueryCache, QueryClient } from "@tanstack/vue-query";
export const pluginHook = defineVueQueryPluginHook(() => {
  const useSession = useSessionStore();
  const onError = async ({ response }) => {
    let errorMessage = `Please try again or contact support.`;
    let apiErrorMessage = "";
    if (response?._data?.error?.message) {
      apiErrorMessage = response._data.error.message;
    } else if (response?._data?.error?.Message) {
      apiErrorMessage = response._data.error.Message;
    }
    if (response?.status === 401) {
      await useSession.timeout();
    } else if (response?.status >= 400 && apiErrorMessage) {
      errorMessage = apiErrorMessage;
    } else if (apiErrorMessage) {
      errorMessage = apiErrorMessage;
    }
    if (response?._data?.errors && response?._data?.errors.length) {
      errorMessage = response._data.errors[0].message;
    }
    if (response?._data?.message) {
      errorMessage = response?._data?.message;
    }
    if (response?._data?.data?.message) {
      errorMessage = response?._data?.data?.message;
    }
    isLoadingSpinner(false);
    toastError("Error", errorMessage, 5e3);
  };
  const onSuccess = async () => {
    useSession.resetTimer();
  };
  const queryCache = new QueryCache({
    onSuccess,
    onError
  });
  const queryClient = new QueryClient({
    queryCache,
    // Use the queryCache with handlers
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1e3,
        enabled: true,
        retry: 0,
        refetchOnWindowFocus: false
      },
      mutations: {
        // These still work for mutations
        onSuccess,
        onError
      }
    }
  });
  window.__TANSTACK_QUERY_CLIENT__ = queryClient;
  return {
    pluginReturn: {},
    vueQueryPluginOptions: { queryClient }
  };
});
